import React, { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import './style.css'
import { meta } from '../../content_option'
import ReactMarkdown from 'react-markdown'
import { getPostBySlug } from '../../utils/blogUtils'

export const BlogPost = () => {
  const { slug } = useParams()
  const [post, setPost] = useState({
    content: '',
    metadata: {
      title: '',
      date: '',
      description: ''
    }
  })
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const postData = await getPostBySlug(slug);
        
        if (postData) {
          setPost({
            content: postData.content,
            metadata: postData.metadata,
          })
          setError(null)
        } else {
          setError('post-not-found')
          console.error('Post not found')
        }
      } catch (error) {
        console.error('Error loading blog post:', error);
        setError('fetch-error');
      } finally {
        setLoading(false);
      }
    }

    fetchPost();
  }, [slug])

  if (loading) {
    return (
      <section className="blog-post">
        <div className="blog-container">
          <div className="loading">Loading...</div>
        </div>
      </section>
    )
  }
  
  if (error) {
    return (
      <HelmetProvider>
        <section className="blog-post">
          <Helmet>
            <meta charSet="utf-8" />
            <title>Post Not Found | {meta.title}</title>
          </Helmet>
          <div className="blog-container error-container">
            <Link to="/blog" className="back-link">← Back to Blog</Link>
            <div className="error-content">
              <h1>{error === 'post-not-found' ? 'Post Not Found' : 'Error Loading Post'}</h1>
              <p>
                {error === 'post-not-found' 
                  ? `Sorry, the blog post "${slug}" could not be found.` 
                  : 'There was a problem loading this blog post. Please try again later.'}
              </p>
              <Link to="/blog" className="error-button">
                Return to Blog Home
              </Link>
            </div>
          </div>
        </section>
      </HelmetProvider>
    )
  }

  return (
    <HelmetProvider>
      <section className="blog-post">
        <Helmet>
          <meta charSet="utf-8" />
          <title>{post.metadata.title || 'Blog Post'} | {meta.title}</title>
          <meta name="description" content={post.metadata.description || meta.description} />
        </Helmet>
        <div className="blog-container">
          <div className="blog-header">
            <Link to="/blog" className="back-link">← Back to Blog</Link>
            <h1 className="blog-title">{post.metadata.title}</h1>
            {post.metadata.date && <div className="blog-date">{post.metadata.date}</div>}
          </div>
          <div className="blog-content markdown-content">
            <ReactMarkdown>
              {post.content}
            </ReactMarkdown>
          </div>
        </div>
      </section>
    </HelmetProvider>
  )
}